import ApiConnector from "@/repository/connector";
import Analytics from "./Analytics";
import Activity from "./Activity";

class Supervision {
  Analytics = Analytics
  Activity = Activity

  get = async (params) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/supervisions/`, { params });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  getOne = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/supervisions/${id}/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  getOpen = async () => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/supervisions/last-active-supervision/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  create = async ({ worker, organization, name }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/`, { worker, organization, name });
    result.value = response.data;
    result.error = response
    return result;
  };
  failure = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/failure/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  setVerified = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/verify/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  resetVerified = async ({ id }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.post(`/api/supervisions/${id}/clear-verification/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  updateAdminComment = async ({ id, admin_comment, organization }) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.patch(`/api/supervisions/${id}/`, { admin_comment, organization });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  deleteNotVerified = async (params) => {
    const result = {
      value: null,
      error: null,
    };
    const response = await ApiConnector.connector.post(
      `/api/supervisions/delete-not-verified/`,
      null,
      { params }
    );
    result.value = response.data;
    result.error = response.detail;
    return result;
  };
  export = async ({ timezone = "Europe/Moscow" } = {}) => {
    const result = {
      value: null,
      error: null,
    };
    try {
      const response = await ApiConnector.connector.get(
        `/api/supervisions/export/`,
        {
          params: { timezone },
          responseType: "blob",
        }
      );

      // Проверяем Content-Type заголовок, чтобы определить, не является ли ответ ошибкой в формате JSON
      const contentType = response.headers["content-type"] || "";
      if (contentType.includes("application/json")) {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        result.error = errorData;
        return result;
      }

      // Создаем ссылку для скачивания файла
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Получаем имя файла из заголовка Content-Disposition или используем дефолтное
      const contentDisposition = response.headers["content-disposition"];
      let filename = "supervisions_export.xlsx";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      result.value = true;
    } catch (error) {
      // Если ошибка в формате blob, пытаемся прочитать как JSON
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          result.error = errorData;
        } catch {
          result.error = error.response?.data || error;
        }
      } else {
        result.error = error.response?.data || error;
      }
    }
    return result;
  };
}

export default new Supervision()